import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance70 = () => {
  let winners = ["534"];
  return <IndividualTable matchType={"3"} gender="F" event="70" subTitle="Puta" data={sampleData2} topRankCount="1" winners={winners} />;
};
export default Distance70;
